import GameSignals from '@/signals/GameSignals'
import { BaseChildState } from '@stateMachine/BaseChildState'
import Facade from '@/Facade'
import { GameStatesEnum } from '@/states/GameStatesEnum'

export class FreeSpinsIntroState extends BaseChildState {
    private _transitionFallbackTimeoutId: number = null
    private _isTransitionCompleted: boolean = false
    private _isCompleted: boolean = false

    public canTrigger(): boolean {
        const freebetGiven = Number(this._model.spinData?.bonus?.freebet_given || 0)

        return (
            !this._model.spinState.isHoldAndWinActive &&
            !this._model.roundState.isFreeSpins &&
            freebetGiven > 0
        )
    }

    public begin() {
        ;(Facade as any).skipFinalWinPresentationAfterHoldAndWin = false
        GameSignals.completeTransitionAnimation.connect(this.onTransitionComplete)
        // Start the first FS spin as soon as the player dismisses the Congrats popup —
        // do not wait for the outro clip (~0.5s) on featureIntroContinue.
        ;(GameSignals as any).featurePopupDismissStarted?.connect(this.onIntroComplete)
        ;(GameSignals as any).featureIntroContinue?.connect(this.onIntroComplete)

        this._isTransitionCompleted = false
        this._isCompleted = false

        this._model.isBonusGameNow = true
        this._model.roundState.isFreeSpins = true

        // Keep this signal for reels strip/sound sync, while the visual popup is handled by FeatureIntroPopupComponent.
        GameSignals.showFreeSpinsIntro.emit(this._model.spinData?.bonus?.freebet_given)
        GameSignals.showFreeSpinsBackground.emit()

        // Keep the flow unified without showing the legacy wave transition in FS intro.
        this._transitionFallbackTimeoutId = window.setTimeout(this.onTransitionComplete, 150)
    }

    private onTransitionComplete = () => {
        if (this._isTransitionCompleted) {
            return
        }

        this._isTransitionCompleted = true

        if (this._transitionFallbackTimeoutId !== null) {
            clearTimeout(this._transitionFallbackTimeoutId)
            this._transitionFallbackTimeoutId = null
        }

        ;(GameSignals as any).featureIntroRequested?.emit({
            kind: 'freespins',
            freeSpinsCount: this._model.spinData?.bonus?.freebet_given,
        })
    }

    private onIntroComplete = () => {
        if (this._isCompleted) {
            return
        }

        this._isCompleted = true

        if (this._transitionFallbackTimeoutId !== null) {
            clearTimeout(this._transitionFallbackTimeoutId)
            this._transitionFallbackTimeoutId = null
        }

        GameSignals.bonusStartComplete.emit()
        // Jump straight to the first FS spin — do not walk remaining FinalState children
        // (Retrigger used to match the initial award and add a multi-second wait).
        this.cleanUp()
        this._stateMachine.setState(GameStatesEnum.START_SPIN_STATE)
    }

    public cleanUp() {
        if (this._transitionFallbackTimeoutId !== null) {
            clearTimeout(this._transitionFallbackTimeoutId)
            this._transitionFallbackTimeoutId = null
        }

        ;(GameSignals as any).featurePopupDismissStarted?.disconnect(this.onIntroComplete)
        ;(GameSignals as any).featureIntroContinue?.disconnect(this.onIntroComplete)
        GameSignals.completeTransitionAnimation.disconnect(this.onTransitionComplete)
    }
}
